import httpClient from '@/plugins/axios'

const handleError = (e: any) => {
  if (process.env.NODE_ENV !== 'production') console.log(e)
  // if (e.response && e.response.data.message) {
  //   alert(e.response.data.message);
  // } else {
  //   alert('システムーエラーが発生しました');
  // }
  throw e
}

const getRequest = async (url: string, data?: any): Promise<any> => {
  try {
    const res = await httpClient.get(url, data)
    return res
  } catch (error) {
    handleError(error)
  }
}

const postRequest = async (url: string, data?: any): Promise<any> => {
  try {
    const res = await httpClient.post(url, data)
    return res
  } catch (error) {
    handleError(error)
  }
}

const putRequest = async (url: string, data?: any): Promise<any> => {
  try {
    const res = await httpClient.put(url, data)
    return res
  } catch (error) {
    handleError(error)
  }
}

const deleteRequest = async (url: string, data?: any): Promise<any> => {
  try {
    const res = await httpClient.delete(url, data)
    return res
  } catch (error) {
    handleError(error)
  }
}

export {
  getRequest as get,
  postRequest as post,
  putRequest as put,
  deleteRequest as delete
}
